// =============================================================================
// FILE:
// frontend/src/modules/pms/material_logistics/components/ApproveDispatchDialog.js
// =============================================================================

import React, {
  useEffect,
  useState
} from "react";

import {
  X
} from "lucide-react";

import {
  getWarehouseList
} from "../services/warehouseService";

import {
  approveDispatch
} from "../services/materialDispatchService";


// =============================================================================
// COMPONENT
// =============================================================================

export default function ApproveDispatchDialog({

  open,

  dispatchId,

  onClose,

  onSuccess

}) {

  // ===========================================================================
  // STATE
  // ===========================================================================
  const [loading, setLoading] =
    useState(false);

  const [saving, setSaving] =
    useState(false);

  const [warehouses, setWarehouses] =
    useState([]);

  const [sourceWarehouseId,
    setSourceWarehouseId] =
      useState("");


  // ===========================================================================
  // LOAD WAREHOUSES
  // ===========================================================================
  const loadWarehouses = async () => {
  try {
    setLoading(true);

    console.log("DEBUG 1: Calling getWarehouseList");

    //debugger;
    const response = await getWarehouseList();

    console.log("DEBUG 2: API Response:", response);
    console.log("DEBUG 3: Response data:", response?.data);
    console.log("DEBUG 4: Success:", response?.success);

    if (response?.success) {
      console.log("DEBUG 5: Warehouse records:", response.data);

      setWarehouses(response.data || []);

      console.log(
        "DEBUG 6: Warehouse records count:",
        response.data?.length
      );
    } else {
      console.error("DEBUG: API returned success=false", response);
    }

  } catch (err) {
    console.error("DEBUG: Warehouse loading failed:", err);
    console.error("DEBUG: Error response:", err.response);
    console.error("DEBUG: Request URL:", err.config?.baseURL, err.config?.url);

  } finally {
    setLoading(false);
  }
};

  // ===========================================================================
  // INITIAL LOAD
  // ===========================================================================
  useEffect(() => {

    if (open) {

      loadWarehouses();
    }

  }, [open]);


  // ===========================================================================
  // HANDLE APPROVE
  // ===========================================================================
  const handleApprove =
    async () => {

      try {

        if (!sourceWarehouseId) {

          alert(
            "Please select source warehouse"
          );

          return;
        }

        setSaving(true);

        const response =
          await approveDispatch(

            dispatchId,

            {
              source_warehouse_id:
                sourceWarehouseId
            }
          );

        if (response?.success) {

          alert(
            "Dispatch approved successfully"
          );

          if (onSuccess) {

            onSuccess();
          }

          onClose();
        }

      } catch (err) {

        console.error(err);

        alert(

          err?.response?.data?.message ||

          "Failed to approve dispatch"
        );

      } finally {

        setSaving(false);
      }
    };


  // ===========================================================================
  // HIDE
  // ===========================================================================
  if (!open) {

    return null;
  }


  // ===========================================================================
  // RENDER
  // ===========================================================================
  return (

    <>

      {/* ================================================================ */}
      {/* OVERLAY */}
      {/* ================================================================ */}
      <div style={styles.overlay} />


      {/* ================================================================ */}
      {/* DIALOG */}
      {/* ================================================================ */}
      <div style={styles.dialog}>


        {/* ============================================================ */}
        {/* HEADER */}
        {/* ============================================================ */}
        <div style={styles.header}>


          <div>

            <div style={styles.title}>
              Approve Dispatch
            </div>

            <div style={styles.subTitle}>

              Select source warehouse
              for inventory movement

            </div>

          </div>


          <button
            style={styles.closeBtn}
            onClick={onClose}
          >

            <X size={18} />

          </button>

        </div>


        {/* ============================================================ */}
        {/* BODY */}
        {/* ============================================================ */}
        <div style={styles.body}>


          {

            loading ? (

              <div style={styles.loader}>
                Loading warehouses...
              </div>

            ) : (

              <>

                <label style={styles.label}>
                  Source Warehouse
                </label>

                <select
                  value={sourceWarehouseId}
                  onChange={(e) =>
                    setSourceWarehouseId(
                      e.target.value
                    )
                  }
                  style={styles.select}
                >

                  <option value="">
                    Select Warehouse
                  </option>

                  {

                    warehouses.map((row) => (

                      <option
                        key={row.id}
                        value={row.id}
                      >

                        {

                          row.warehouse_name
                        }

                      </option>
                    ))
                  }

                </select>

              </>
            )
          }

        </div>


        {/* ============================================================ */}
        {/* FOOTER */}
        {/* ============================================================ */}
        <div style={styles.footer}>


          <button
            style={styles.cancelBtn}
            onClick={onClose}
          >
            Cancel
          </button>


          <button
            style={styles.approveBtn}
            onClick={handleApprove}
            disabled={saving}
          >

            {

              saving
                ? "Approving..."
                : "Approve Dispatch"
            }

          </button>

        </div>

      </div>

    </>
  );
}


// =============================================================================
// STYLES
// =============================================================================

const styles = {

  overlay: {

    position: "fixed",

    top: 0,

    left: 0,

    right: 0,

    bottom: 0,

    background:
      "rgba(0,0,0,0.35)",

    zIndex: 1200
  },

  dialog: {

    position: "fixed",

    top: "50%",

    left: "50%",

    transform:
      "translate(-50%, -50%)",

    width: "500px",

    background: "#ffffff",

    borderRadius: 14,

    zIndex: 1201,

    display: "flex",

    flexDirection: "column"
  },

  header: {

    padding: 20,

    borderBottom:
      "1px solid #e5e7eb",

    display: "flex",

    justifyContent: "space-between",

    alignItems: "center"
  },

  title: {

    fontSize: 20,

    fontWeight: 700
  },

  subTitle: {

    marginTop: 4,

    fontSize: 13,

    color: "#6b7280"
  },

  closeBtn: {

    width: 36,

    height: 36,

    borderRadius: 8,

    border:
      "1px solid #d1d5db",

    background: "#ffffff",

    cursor: "pointer"
  },

  body: {

    padding: 20
  },

  loader: {

    textAlign: "center",

    padding: 30
  },

  label: {

    display: "block",

    marginBottom: 10,

    fontWeight: 600
  },

  select: {

    width: "100%",

    height: 44,

    border:
      "1px solid #d1d5db",

    borderRadius: 8,

    padding: "0 12px"
  },

  footer: {

    padding: 20,

    borderTop:
      "1px solid #e5e7eb",

    display: "flex",

    justifyContent: "flex-end",

    gap: 12
  },

  cancelBtn: {

    border:
      "1px solid #d1d5db",

    background: "#ffffff",

    borderRadius: 8,

    padding: "10px 18px",

    cursor: "pointer"
  },

  approveBtn: {

    background: "#2563eb",

    color: "#ffffff",

    border: "none",

    borderRadius: 8,

    padding: "10px 18px",

    cursor: "pointer"
  }
};